import { Clapperboard, Mic, X, UserPlus } from "lucide-react";

export default function ViewersList({ viewers, drivers = [], myId, canManage, onInviteCoDriver, onRemoveDriver, voiceIds }) {
  const inVoice = (id) => voiceIds && voiceIds.has && voiceIds.has(id);
  const driverIds = new Set(drivers.map((d) => d.id));
  const seatsFull = drivers.length >= 2;

  const handleClick = (v, isDriverAvatar) => {
    if (!canManage) return;
    if (isDriverAvatar) {
      onRemoveDriver && onRemoveDriver(v.id);
    } else if (!seatsFull) {
      onInviteCoDriver && onInviteCoDriver(v.id);
    }
  };

  return (
    <div
      data-testid="viewers-list"
      className="flex gap-3 p-4 border-b border-[#00D9FF]/10 overflow-x-auto scrollbar-hide shrink-0 items-start bg-[#0A0E27]/80"
    >
      <span className="text-xs font-display font-bold uppercase tracking-wider shrink-0 mt-2.5">
        <span className="neon-cyan">{viewers.length}</span>
        <span className="text-[#88A0C0]"> watching</span>
      </span>
      <div className="flex gap-2.5 items-start">
        {viewers.map((v) => {
          const isDriverAvatar = driverIds.has(v.id);
          const isMe = v.id === myId;
          const actionable = canManage && (isDriverAvatar || !seatsFull);
          const title = !canManage
            ? `${v.name} · ${isDriverAvatar ? "Driver" : "Passenger"}`
            : isDriverAvatar
              ? (isMe ? "Step down to passenger" : `Remove ${v.name} as co-driver`)
              : seatsFull
                ? "Both driver seats are full"
                : `Make ${v.name} a co-driver`;
          return (
            <button
              key={v.id}
              data-testid={`viewer-${v.name}`}
              onClick={() => handleClick(v, isDriverAvatar)}
              title={title}
              className={`relative shrink-0 group flex flex-col items-center gap-1 ${actionable ? "cursor-pointer" : "cursor-default"}`}
            >
              <div className="relative">
                <div
                  className={`w-10 h-10 rounded-full bg-[#060817] border flex items-center justify-center text-lg transition-all ${
                    isDriverAvatar
                      ? "border-[#00D9FF] badge-pulse-cyan"
                      : "border-[#9D4EDD]/40 group-hover:border-[#9D4EDD]"
                  }`}
                >
                  {v.flag}
                </div>
                {isDriverAvatar && (
                  <span data-testid={`driver-badge-${v.name}`} className="absolute -top-1.5 -left-1.5 w-4 h-4 rounded-full bg-[#00D9FF] flex items-center justify-center badge-pulse-cyan" title="Driver">
                    <Clapperboard className="w-2.5 h-2.5 text-navy-ink" />
                  </span>
                )}
                {canManage && isDriverAvatar && (
                  <span data-testid={`remove-driver-${v.name}`} className="absolute -bottom-1 -left-1.5 w-4 h-4 rounded-full bg-[#0A0E27] border border-[#FF006E]/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <X className="w-2.5 h-2.5 text-[#FF006E]" />
                  </span>
                )}
                {canManage && !isDriverAvatar && !seatsFull && (
                  <span data-testid={`invite-codriver-${v.name}`} className="absolute -bottom-1 -left-1.5 w-4 h-4 rounded-full bg-[#0A0E27] border border-[#00D9FF]/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                    <UserPlus className="w-2.5 h-2.5 text-[#00D9FF]" />
                  </span>
                )}
                {inVoice(v.id) && (
                  <span data-testid={`voice-badge-${v.name}`} className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-[#00FF66] flex items-center justify-center border-2 border-[#0A0E27]" title="In voice" style={{ boxShadow: "0 0 8px #00FF66" }}>
                    <Mic className="w-2 h-2 text-navy-ink" />
                  </span>
                )}
                <span className="absolute -bottom-1 -right-1 w-3 h-3 rounded-full bg-[#00FF66] border-2 border-[#0A0E27]" style={{ boxShadow: "0 0 6px #00FF66" }} />
              </div>
              <span className={`text-[9px] font-bold leading-none whitespace-nowrap font-display uppercase tracking-wide ${isDriverAvatar ? "neon-cyan" : "neon-purple"}`}>
                {isDriverAvatar ? "🎬 Driver" : "👁 Passenger"}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
